import {NgModule} from '@angular/core';

import {ImgSrcToBackground} from '@wallex-core-client/pipes';

@NgModule({
  declarations: [ImgSrcToBackground],
  exports: [ImgSrcToBackground]
})
export class ImgSrcToBackgroundPipeModule {}
